import { compose, lifecycle } from 'recompose';
import moment from 'moment-timezone';
import withTimezone from '../../../auth/utils/withTimezone';
import withFetchTimeTrackingBarbers from './withFetchTimeTrackingBarbers';

const barberListFetchTimeTracking = compose(
  withFetchTimeTrackingBarbers,
  withTimezone,
  lifecycle({
    componentDidMount() {
      const today = moment.tz(this.props.timezone);
      const filters = {
        startedAt__gte: today.startOf('day').toJSON(),
        startedAt__lte: today.endOf('day').toJSON(),
      };
      this.props.fetchTimeTrackingBarbers(filters);
    },
  })
);
export default barberListFetchTimeTracking;
